<div [ngClass]="commonService.isHidden ?'main-container':'container-fluid'">
    <!-- Tiles Section Start -->
    <div class="row">
        <div class="col-sm-12 col-xs-12 col-md-6 col-xl-3 pt-4">
            <div class="card custom-card card-primary">
                <div class="card-title">
                    <span class="d-block mb-1 fw-medium">Units (Booked / Total)</span>
                </div>
                <div class="card-body">
                    <!-- <div class="d-flex align-items-start justify-content-between flex-wrap" style="border: dotted;"> -->
                    <h3 class="fw-semibold card-value lh-1 mb-0">{{totalUnitSold + ' / ' +totalUnitsSum}}</h3>
                    <!-- </div> -->
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-xs-12 col-md-6 col-xl-3 pt-4">
            <div class="card custom-card card-info">
                <div class="card-title">
                    <span class="d-block mb-1 fw-medium">Sale</span>
                </div>
                <div class="card-body">
                    <!-- <div class="d-flex align-items-start justify-content-between flex-wrap" style="border: dotted;"> -->
                    <h3 class="fw-semibold card-value lh-1 mb-0">₹ {{totalAmountSoldUnit}}</h3>
                    <!-- </div> -->
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-xs-12 col-md-6 col-xl-3 pt-4">
            <div class="card custom-card card-positive">
                <div class="card-title-light">
                    <span class="d-block mb-1 fw-medium">Collection</span>
                </div>
                <div class="card-body-light">
                    <!-- <div class="d-flex align-items-start justify-content-between flex-wrap" style="border: dotted;"> -->
                    <h3 class="fw-semibold card-value lh-1 mb-0">₹ {{totalAmountReceived}}</h3>
                    <!-- </div> -->
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-xs-12 col-md-6 col-xl-3 pt-4">
            <div class="card custom-card card-danger">
                <div class="card-title-light">
                    <span class="d-block mb-1 fw-medium">Balance</span>
                </div>
                <div class="card-body-light">
                    <!-- <div class="d-flex align-items-start justify-content-between flex-wrap" style="border: dotted;"> -->
                    <h3 class="fw-semibold card-value lh-1 mb-0">₹ {{totalBalancedAmountSum}}</h3>
                    <!-- </div> -->
                </div>
            </div>
        </div>
    </div>
    <!-- Tiles Section Ends -->

    <!-- Charts Section Starts -->
    <div class="row p-3">
        <div class="col-12 chart-common">
            <app-dynamic-chart [chartOptions]="chartOptions"
                [chartData]="monthWieWeeklySaleChartData"></app-dynamic-chart>
        </div>
    </div>
    <div class="row p-3">
        <div class="col-6 chart-common">
            <app-common-chart [chartOptions]="unitCategoryCharOptions"></app-common-chart>
        </div>
    </div>
    <!-- Charts Section Ends -->
</div>